// 品番マスタ本体の保存ペイロード(data / detail)の組み立てをまとめる。
// 本文は HinbanMaster.js から移設したもの。

export function createMainSavePayloadBuilder(deps) {
    const {
        DETAIL_HEADER_PANEL,
        DicVal,
        GridData,
        collectBasePanelColumnIds,
        collectKakousijiPanelColumnIds,
        entrydataRef,
        findEntryValue,
        isEmpty,
        isKakousijiPanelType,
        jyutakuHasuShoriKbnColumnIdCandidates,
        jyutakuHasuShoriPosColumnIdCandidates,
        normalizeNumericPayloadObject,
        pdtItemCodesPanel,
        sanitizeEntryData,
        sectionHeaderData,
        storeentrydata,
        syncPdtBrandCodeAlias
    } = deps;

    function buildMainSaveDetail(detailSource) {
        const next = {};
        Object.keys(isEmpty(detailSource) ? {} : detailSource).forEach((type) => {
            if (isKakousijiPanelType(type)) return;
            next[type] = (Array.isArray(detailSource[type]) ? detailSource[type] : []).map((row) => normalizeNumericPayloadObject(row));
        });
        return next;
    }
    function normalizeKonpoGrpForSave(data) {
        if (isEmpty(data)) return data;
        const konpoGrp = String(DicVal(data, "PDT_KONPOGRP", "")).trim();
        if (konpoGrp === "") return data;
        data.PDT_KONPOGRP = konpoGrp.split(":")[0].trim();
        return data;
    }
    function applyPdtItemDetailCodesForSave(data) {
        if (isEmpty(data)) return data;
        const rows = GridData(pdtItemCodesPanel());
        const detailRows = Array.isArray(rows) ? rows : [];
        for (let i = 1; i <= 10; i++) {
            data[`PDT_ITMCITEMCD${i}`] = String(DicVal(DicVal(detailRows, i - 1, {}), "PDT_ITMCITEMCD", "") ?? "").trim();
        }
        return data;
    }
    function applyJyutakuHasuShoriFieldsForSave(data) {
        if (isEmpty(data)) return data;
        data.PDT_JYUHASUPOSITION = String(findEntryValue(data, jyutakuHasuShoriPosColumnIdCandidates) ?? "").trim();
        data.PDT_JYUHASUKBN = String(findEntryValue(data, jyutakuHasuShoriKbnColumnIdCandidates) ?? "").trim();
        return data;
    }
    function applyPdtTenkaiCodeForSave(data) {
        if (isEmpty(data)) return data;
        const headerValue = String(DicVal(sectionHeaderData(DETAIL_HEADER_PANEL), "PDT_TENKAICODE", "") ?? "").trim();
        const dataValue = String(DicVal(data, "PDT_TENKAICODE", "") ?? "").trim();
        const currentValue = String(DicVal(entrydataRef.current, "PDT_TENKAICODE", "") ?? "").trim();
        const storeValue = String(DicVal(storeentrydata, "PDT_TENKAICODE", "") ?? "").trim();
        data.PDT_TENKAICODE = headerValue || dataValue || currentValue || storeValue;
        if (data.PDT_TENKAICODE !== "" && !isEmpty(entrydataRef.current)) entrydataRef.current.PDT_TENKAICODE = data.PDT_TENKAICODE;
        return data;
    }
    function buildMainSaveData() {
        const next = sanitizeEntryData(entrydataRef.current);
        syncPdtBrandCodeAlias(next);
        normalizeKonpoGrpForSave(next);
        applyPdtItemDetailCodesForSave(next);
        applyJyutakuHasuShoriFieldsForSave(next);
        applyPdtTenkaiCodeForSave(next);
        const oppiCode = String(DicVal(next, "PDT_OPPICD", "") ?? "").trim();
        if (oppiCode !== "") next.PDTMD_OPPICD = oppiCode;
        const brandCodeKeys = Object.keys(isEmpty(next) ? {} : next).filter((key) => /BRDCODE/i.test(String(key)));
        if (brandCodeKeys.length !== 0) {
        } else {
        }
        const baseColumnIds = collectBasePanelColumnIds();
        collectKakousijiPanelColumnIds().forEach((columnId) => {
            if (baseColumnIds.includes(columnId)) return;
            delete next[columnId];
        });
        return next;
    }

    return {
        buildMainSaveDetail,
        normalizeKonpoGrpForSave,
        applyPdtItemDetailCodesForSave,
        applyJyutakuHasuShoriFieldsForSave,
        applyPdtTenkaiCodeForSave,
        buildMainSaveData
    };
}
